export const PATH = {
    HOME: '/',
    ENROLL: '/enroll',
    LOGIN: '/login',
    SELLER: '/seller',
    /** Admin app — the management dashboard (landing for a BranchAdmin). */
    MANAGE: '/manage',
    /** Admin app — the transactions list (first sidebar page). */
    TRANSACTIONS: '/transactions',
    /** Admin app — the branch's shift register. */
    SHIFTS: '/shifts',
    NOT_FOUND: '/404',
};
